export default "__VITE_ASSET__CGwskNk9__"